import config from './config';

export const msalConfig = {
    auth: {
        clientId: config.azureClientId,
        authority: `https://login.microsoftonline.com/${config.azureTenantId}`,
        redirectUri: config.msalRedirectUri,
        postLogoutRedirectUri: config.msalRedirectUri,
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true, // Helps with IE11/Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case "Error":
                        console.error(message);
                        break;
                    case "Info":
                        console.info(message);
                        break;
                    case "Verbose":
                        console.debug(message);
                        break;
                    case "Warning":
                        console.warn(message);
                        break;
                }
            },
            piiLoggingEnabled: false,
        },
    },
};

// Add token renewal settings
export const tokenRenewalConfig = {
    silentRequestTimeoutMs: 10000, // Timeout for silent token renewal (10 seconds)
};

export const loginRequest = {
    scopes: ["User.Read", "openid", "profile", "email"], // Define the scopes you need
    prompt: "select_account" // This forces the account selection prompt
};